// extracted by mini-css-extract-plugin
export default {"QuestionSlide":"QuestionSlide_QuestionSlide__SXV1+","title":"QuestionSlide_title__H89qH","label":"QuestionSlide_label__JUSnc","video":"QuestionSlide_video__aNOQa"};